export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./attach-contact.vue?vue&type=template&id=ed2b3f78&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/attach-contact.vue?vue&type=template&id=ed2b3f78&
// module id = 1685
// module chunks = 0